interface LayoutProps {
  children?: React.ReactNode | React.ReactNode[];
}

const LargeLayout: React.FC<LayoutProps> = ({ children }) => {
  const sizeClasses =
    'relative pb-header-height laptop:mx-auto laptop:max-xl-content laptop:mb-128 z-0 mt-[156px] laptop:px-24 px-16';
  const layoutClasses =
    'flex flex-col items-center tablet:mx-auto laptop:mx-auto gap-128 laptop:gap-192';

  return (
    <div className={sizeClasses}>
      <div className={layoutClasses}>{children}</div>
    </div>
  );
};

export default LargeLayout;
